import React from 'react';
import RootLayout from "@/app/layout";
import { KontaktSection } from '@/app/components/Sections/KontaktSection';
import data from '../../data/kontakt/data.json';
import Head from 'next/head';

export const metadata = {
    title: 'Hebamme Lea Stiffler | Kontakt',
    description: 'Nehmen Sie Kontakt auf mit Lea Stiffler für professionelle Hebammenbetreuung in Chur. Finden Sie alle Kontaktdetails für Ihre Fragen und Terminvereinbarungen.',
    keywords: 'Kontakt Hebamme, Lea Stiffler Hebamme, Hebammenbetreuung Chur, Hebamme Kontaktinformation, Schwangerschaftsbetreuung Chur, Hebamme Termin Chur',
    canonicalUrl: 'https://hebamme-leastiffler.ch/kontakt'
}

export async function getStaticProps() {
    return { props: { data } }
}

export default function Kontakt({ data }) {
    return (
        <RootLayout>
            <Head>
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
            </Head>
            <KontaktSection data={data} />
        </RootLayout>
    );
}
